import React, { useEffect, useState } from "react";
import RolloGuardadoModal from "../../components/ingresos/RolloGuardadoModal";
import { ListadoRollos, TRollo } from "../../components/ingresos/rollos/ListadoRollos";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import styles from "./Detalle.module.css";
import { useParams } from "react-router-dom";

type TIngreso = {
  uuid: string;
  ticket: string;
  fecha_ingreso: string;
  celda: string;
  cliente: {
    denominacion: string;
    ndoc: string;
  };
  kg_bruto: number;
  kg_tara: number;
  cantidad_rollos: number;
  rollos_grabados: number;
  rollos: TRollo[];
};

const Detalle = () => {
  const { uuid } = useParams();
  console.log("UUID:", uuid);
  const [ingreso, setIngreso] = useState<TIngreso | undefined>(undefined);
  const [rollos, setRollos] = useState<TRollo[] | undefined>(undefined);
  const [isDirty, setDirty] = useState(false);
  const [guardado, setGuardado] = useState(false);

  const { getAccessTokenSilently } = useAuth0();

  // const { user, error, isLoading } = useUser();

  const modalToggle = () => {
    setGuardado(!guardado);
  };

  const guardarRollos = async () => {
    console.log("Guardando rollos...");
    console.log(rollos);
    try {
      const accessToken = await getAccessTokenSilently();
      const apiEndpoint = `${process.env.REACT_APP_API_URL}/ingresos/${uuid}/rollos`;
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`,
        },
        body: JSON.stringify(rollos?.map((rollo: TRollo) => rollo.rollo_id)),
      });
      console.log(response.status);
      switch (response.status) {
        case 200:
          setGuardado(true);
          break;
        case 400:
          const data = await response.json();
          console.log(data);
          switch (data.message) {
            case "ROLLO_DUPLICADO":
              alert(
                `Rollo duplicado: Los rollos que intenta cargar ya existen en otro ticket`
              );
              return;
            case "ROLLO_ID_INVALIDO":
              alert(
                `Codigo de rollo invalido: \nDebe ingresar un codigo alfanumerico de 24 caracteres.\nO tambien numero de serie de 11 digitos numéricos`
              );
              return;
            default:
              alert(
                `Ha ocurrido un error al guardar el rollo. Por favor, contactar a soporte.`
              );
              return;
          }
        default:
          alert(
            `Ha ocurrido un error inesperado. Por favor, contactar a soporte.`
          );
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchDetalleIngresos = async () => {
    if (!uuid) return;
    // TODO: validate uuid
    try {
      const accessToken = await getAccessTokenSilently();
      const apiEndpoint = `${process.env.REACT_APP_API_URL}/ingresos/${uuid}`;
      const response = await fetch(apiEndpoint, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      // console.log("Rollos:", data.data.rollos);
      setIngreso(data.data);
      setRollos(data.data.rollos);
      // console.log("Ingreso: ", data.data);
    } catch (e: any) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchDetalleIngresos();
  }, [uuid]);

  return (
    <div>
      <div className="container d-flex flex-wrap p-md-0">
        <div className="content-left content-left-profile">
          <div className="az-profile-overview">
            <div className="d-flex justify-content-between mg-b-20">
              <div>
                <h5>Ingreso de camión</h5>
                <p>
                  Nro de Ticket: <span>{ingreso?.ticket}</span>
                  <br />
                  Celda: <span>{ingreso?.celda}</span>
                </p>
              </div>
            </div>
            <hr className="mg-y-30" />
            <label className="az-content-label tx-13 mg-b-20">DETALLES</label>
            <div className={styles["profile-social-list"]}>
              <div>
                <span>Cliente:</span>
                <span>{ingreso?.cliente.denominacion}</span>
                <span className={styles["value-emphasis"]}>{ingreso?.cliente.ndoc}</span>
              </div>
              <div>
                <span>Peso:</span>
                <span>Kg Bruto:</span><span className={styles["value-strong"]}>{ingreso?.kg_bruto}</span>
                <span>Kg Tara:</span><span className={styles["value-strong"]}>{ingreso?.kg_tara}</span>
                <span>Subtotal:</span><span className={styles["value-strong"]}>{ingreso?.kg_bruto! - ingreso?.kg_tara!}</span>
              </div>
            </div>
            {ingreso?.cantidad_rollos! > 0 && (
              <ListadoRollos
                ingreso={ingreso}
                rollos={rollos}
                setDirty={setDirty}
              />
            )}
            <RolloGuardadoModal
              showModal={guardado}
              toggleModal={modalToggle}
            />
            <div>
              <button
                className="btn btn-success btn-rounded btn-block"
                type="button"
                disabled={!isDirty}
                onClick={() => {
                  guardarRollos();
                }}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withAuthenticationRequired(Detalle);
